import React, { useEffect, useState} from 'react'
import styles from './UnsavedDocuments.module.css'
import LoadingBackdrop from "../../../components/common/LoadingBackdrop";
import {
    Alert,
    Grid, IconButton,
} from "@mui/material";
import {DataGridPremium, GridRowParams, MuiEvent} from "@mui/x-data-grid-premium";
import {GridCallbackDetails, GridCellParams, GridColDef} from "@mui/x-data-grid-pro";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText} from "@material-ui/core";
import {getConfig} from "../../../AppConfig";
import {db} from "../../WorkReportingPage/db";
import {Delete} from "@mui/icons-material";
import dayjs from "dayjs";
const { secretkey } = getConfig()

const UnsavedDocuments = (params) => {
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const [data, setData] = useState([])
    const [dialogObj, setDialogObj] = React.useState({ msg: "", id: '' })
    const [rowData, setRowData] = React.useState( {generalformsid: null, generalformsgoogledriveid: '', generalformscategory: "", generalformstiedtowo: false, generalformsname: "", generalformsnamebase: "", generalformsreadonly: false, generalformsallowchangefilename: false, generalformsfilename: ""});

    const getDBLocalDocumentsRecord = async () => {
        const dataArray = await db.workreporting.where('uuid').startsWith('localdocuments-').toArray()
        debugger
        if (dataArray && dataArray?.length > 0) {
            const newData = dataArray.map(item => {
                const parsedData = JSON.parse(item.json)
                return {
                    ...parsedData,
                    ...parsedData.decryptedData,
                    id: parsedData.decryptedData.driveid + parsedData.decryptedData.woid
                }
            })
            setData(newData)
        }
        else {
            setData([])
        }
        return dataArray
    }

    useEffect(() => {
        params.setTitle('In Progress')
        getDBLocalDocumentsRecord()
    }, [])


    const handleRowClick = (param : GridRowParams, event: MuiEvent<React.MouseEvent>, details: GridCallbackDetails) => {
        const newRowData = {...param?.row}
        debugger

        var urlTOOpen = '/filesystem/pdfpage/'
        urlTOOpen += newRowData?.driveid + '/' + newRowData?.woid

        var CryptoJS = require("crypto-js");
        var encriptedString = CryptoJS.AES.encrypt(JSON.stringify({
            ...newRowData.decryptedData
        }), secretkey).toString();

        if (rowData?.generalformsgoogledriveid && rowData?.generalformsgoogledriveid?.length > 0) {
            // urlTOOpen += '/' + encodeURIComponent(encriptedString)
            localStorage.setItem('pdfopen-' + rowData?.generalformsgoogledriveid + '-' + newRowData.decryptedData.woid, encriptedString)
        }
        window.open(urlTOOpen)
    }
    const closeDialog = () => {
        setDialogObj({
            msg: '',
            id: ''
        })
    }

    const handleDelete = (params: GridCellParams) => {
        console.log(params)
        debugger
        setDialogObj({
            msg: 'Are you sure you want to delete  \"' + params.row.filename + "\"?",
            id: params.row.driveid + '-' + (params?.row?.woid ? params.row.woid.toString() : 'null')
        })
    }

    const handleDeleteConfirm = async () => {
        const dbKey = 'localdocuments-' + dialogObj.id
        debugger
        db.workreporting.get(dbKey).then(
            (record) => {
                db.workreporting.delete(dbKey)
                getDBLocalDocumentsRecord()
            })
        closeDialog()
    }

    const columns: GridColDef[] = [
        {
            field: 'action',
            headerName: '',
            width: 50,
            align: "center",
            headerAlign: "center",
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
                <>
                    <IconButton className={styles.button} onClick={() => { handleDelete(params) }}>
                        <Delete />
                    </IconButton>
                </>
            )
        },
        {
            field: 'woid',
            type: 'string',
            headerName: 'WO#',
            align: 'left',
            width: 125
        },
        {
            field: 'filename',
            type: 'string',
            headerName: 'Filename',
            width: 700,
            align: 'left',
            headerAlign: 'left',
        },
        {
            field: 'date',
            type: 'string',
            headerName: 'Date',
            width: 700,
            align: 'left',
            headerAlign: 'left',
            valueFormatter: (params) =>
                (params.value ? new Date(params?.value).toLocaleString() : 'N/A')
        },
    ]


    return (
        <div className={styles.root}>
            <LoadingBackdrop open={loadingBackdrop} />
            <>
                <Dialog
                    open={dialogObj.msg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogObj.msg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Cancel</Button>
                        <Button onClick={handleDeleteConfirm}>DELETE</Button>
                    </DialogActions>
                </Dialog>
            </>
            <>
                <div style={{display: loadingBackdrop ? 'none' : 'inline-flex'}}>
                    <Grid
                        container
                        border={0}
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        height={'100%'}
                        width={'100%'}
                    >
                        <>
                            <Grid item border={0} marginRight={1} md={12} xs={12}>
                                {/*<div style={{marginBottom: '50', justifyContent: 'center', alignItems: 'center', alignContent:'center'}} >Add vacation days.</div>*/}
                                <DataGridPremium
                                    rows={data}
                                    columns={columns}
                                    autoHeight={true}
                                    density={'compact'}
                                    pageSize={10}
                                    loading={false}
                                    disableMultipleSelection={true}
                                    // onRowClick={handleRowClick}
                                    onRowDoubleClick={handleRowClick}
                                />
                            </Grid>
                        </>
                    </Grid>
                </div>
            </>
        </div>
    )
}

export default UnsavedDocuments